import { Modal } from "react-bootstrap"
import { Button } from "../../../components"
import { useState } from "react"
import { Calendar } from "react-multi-date-picker"
import { AssociateRescheduleUpdateEndDate } from "../../../utilities/api/associateBooking"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"


const AssociateRescheduleEndDateModal = (props: any) => {
    const { showEndDateModal, handleCloseEndDate, EndDate, id } = props
    const [date, setDate] = useState(EndDate.split("/").reverse().join("-"))
    const [confirmButton, setConfirmButton] = useState(false)
    const navigate = useNavigate()
    const handleDateChange = (e: any) => {
        setDate(e.format("YYYY-MM-DD"))
    }

    const handleConfirm = async () => {
        setConfirmButton(true)
        const result = await AssociateRescheduleUpdateEndDate(id, { endDate: date })
        if (result.status === 200) {
            navigate("/associate-booking-details", { state: id })
            handleCloseEndDate()
        } else {
            toast.error(result.response.data.message)
        }
        setConfirmButton(false)
    }

    return (
        <Modal aria-labelledby="contained-modal-title-vcenter"
            centered show={showEndDateModal} onHide={handleCloseEndDate}>
            <Modal.Header closeButton>
                <Modal.Title>Change End Date</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                <Calendar format="dd-MM-yyyy" value={new Date(date)} onChange={(e: any) => handleDateChange(e)} minDate={new Date().setDate(new Date().getDate() + 1)} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleConfirm} disabled={confirmButton} type="button" bname={confirmButton ? "Updating" : "Confirm"} name="confirm" id="confirm" className="btn btn-primary rounded-1" ></Button>
            </Modal.Footer>
        </Modal>
    )
}

export { AssociateRescheduleEndDateModal }